import { Pipe, PipeTransform } from "@angular/core";
import { PricingPackageType } from "../_services/pricing-packages.service";

@Pipe({
    standalone: true,
    name: "pricingPackageType",
})
export class PricingPackageTypePipe implements PipeTransform {
    transform(value: number): string {
        return PricingPackageType[value];
    }
}
